export enum USAState {
  AL = 'AL', // Alabama
  AK = 'AK', // Alaska
  AZ = 'AZ', // Arizona
  AR = 'AR', // Arkansas
  CA = 'CA', // California
  CO = 'CO', // Colorado
  CT = 'CT', // Connecticut
  DE = 'DE', // Delaware
  FL = 'FL', // Florida
  GA = 'GA', // Georgia
  HI = 'HI', // Hawaii
  ID = 'ID', // Idaho
  IL = 'IL', // Illinois
  IN = 'IN', // Indiana
  IA = 'IA', // Iowa
  KS = 'KS', // Kansas
  KY = 'KY', // Kentucky
  LA = 'LA', // Louisiana
  ME = 'ME', // Maine
  MD = 'MD', // Maryland
  MA = 'MA', // Massachusetts
  MI = 'MI', // Michigan
  MN = 'MN', // Minnesota
  MS = 'MS', // Mississippi
  MO = 'MO', // Missouri
  MT = 'MT', // Montana
  NE = 'NE', // Nebraska
  NV = 'NV', // Nevada
  NH = 'NH', // New Hampshire
  NJ = 'NJ', // New Jersey
  NM = 'NM', // New Mexico
  NY = 'NY', // New York
  NC = 'NC', // North Carolina
  ND = 'ND', // North Dakota
  OH = 'OH', // Ohio
  OK = 'OK', // Oklahoma
  OR = 'OR', // Oregon
  PA = 'PA', // Pennsylvania
  RI = 'RI', // Rhode Island
  SC = 'SC', // South Carolina
  SD = 'SD', // South Dakota
  TN = 'TN', // Tennessee
  TX = 'TX', // Texas
  UT = 'UT', // Utah
  VT = 'VT', // Vermont
  VA = 'VA', // Virginia
  WA = 'WA', // Washington
  WV = 'WV', // West Virginia
  WI = 'WI', // Wisconsin
  WY = 'WY', // Wyoming
}
export const STATES_LIST: { value: USAState; label: string }[] = [
  { value: USAState.AL, label: 'Alabama' },
  { value: USAState.AK, label: 'Alaska' },
  { value: USAState.AZ, label: 'Arizona' },
  { value: USAState.AR, label: 'Arkansas' },
  { value: USAState.CA, label: 'California' },
  { value: USAState.CO, label: 'Colorado' },
  { value: USAState.CT, label: 'Connecticut' },
  { value: USAState.DE, label: 'Delaware' },
  { value: USAState.FL, label: 'Florida' },
  { value: USAState.GA, label: 'Georgia' },
  { value: USAState.HI, label: 'Hawaii' },
  { value: USAState.ID, label: 'Idaho' },
  { value: USAState.IL, label: 'Illinois' },
  { value: USAState.IN, label: 'Indiana' },
  { value: USAState.IA, label: 'Iowa' },
  { value: USAState.KS, label: 'Kansas' },
  { value: USAState.KY, label: 'Kentucky' },
  { value: USAState.LA, label: 'Louisiana' },
  { value: USAState.ME, label: 'Maine' },
  { value: USAState.MD, label: 'Maryland' },
  { value: USAState.MA, label: 'Massachusetts' },
  { value: USAState.MI, label: 'Michigan' },
  { value: USAState.MN, label: 'Minnesota' },
  { value: USAState.MS, label: 'Mississippi' },
  { value: USAState.MO, label: 'Missouri' },
  { value: USAState.MT, label: 'Montana' },
  { value: USAState.NE, label: 'Nebraska' },
  { value: USAState.NV, label: 'Nevada' },
  { value: USAState.NH, label: 'New Hampshire' },
  { value: USAState.NJ, label: 'New Jersey' },
  { value: USAState.NM, label: 'New Mexico' },
  { value: USAState.NY, label: 'New York' },
  { value: USAState.NC, label: 'North Carolina' },
  { value: USAState.ND, label: 'North Dakota' },
  { value: USAState.OH, label: 'Ohio' },
  { value: USAState.OK, label: 'Oklahoma' },
  { value: USAState.OR, label: 'Oregon' },
  { value: USAState.PA, label: 'Pennsylvania' },
  { value: USAState.RI, label: 'Rhode Island' },
  { value: USAState.SC, label: 'South Carolina' },
  { value: USAState.SD, label: 'South Dakota' },
  { value: USAState.TN, label: 'Tennessee' },
  { value: USAState.TX, label: 'Texas' },
  { value: USAState.UT, label: 'Utah' },
  { value: USAState.VT, label: 'Vermont' },
  { value: USAState.VA, label: 'Virginia' },
  { value: USAState.WA, label: 'Washington' },
  { value: USAState.WV, label: 'West Virginia' },
  { value: USAState.WI, label: 'Wisconsin' },
  { value: USAState.WY, label: 'Wyoming' },
];
